import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FilterSortTableDashboard } from "components/FilterSortTable/FilterSortTableDashboard";
import { TaskMeta } from "components/Task/TaskMeta";
import { SeeMore } from "components/Text/SeeMore";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

const allowedFilters = [
  { key: "docCode", value: "Doc. Code" },
  { key: "docDetails", value: "Doc. Details" },
  { key: "taskDetails", value: "Task Details" },
  { key: "deadline", value: "Deadline" },
  { key: "taskByName", value: "Task By" },
  { key: "taskToName", value: "Task To" },
  { key: "taskToOn", value: "Task Assigned Date" },
  { key: "acceptanceStatus", value: "Acceptance Status" },
  { key: "acceptanceOn", value: "Acceptance Date" },
  { key: "doneStatus", value: "Done Status" },
  { key: "doneOn", value: "Done Date" },
  { key: "acknowledgeStatus", value: "Acknowledge Status" },
  { key: "acknowledgeOn", value: "Acknowledge Date" },
];

export const UsersTaskListGridColumns = ({ list, setSortableRecords }) => [
  {
    field: "deadline",
    headerName: "Task Details",
    flex: 1,
    sortable: false,
    renderHeader: (params) => (
      <FlexBox justifyContent="space-between" alignItems="center">
        <FilterSortTableDashboard
          records={list}
          setOutputRecords={setSortableRecords}
          allowedFilters={allowedFilters}
        />
        <Typography>user Task Reports</Typography>
      </FlexBox>
    ),
    renderCell: (params) =>
      params.row.id ? (
        <>
          <FlexBox justifyContent="space-between">
            <Box>
              {params.row.docCode}
              {params.row.docDetails && "- " + params.row.docDetails}
            </Box>
          </FlexBox>
          <FlexBox justifyContent="space-between">
            <Box>
              <SeeMore text={params.row.taskDetails} />
            </Box>
          </FlexBox>
          <TaskMeta
            acceptanceOn={params.row.acceptanceOn}
            acceptanceStatus={params.row.acceptanceStatus}
            deadline={params.row.deadline}
            doneOn={params.row.doneOn}
            doneStatus={params.row.doneStatus}
            taskByName={params.row.taskByName}
            taskDetails={params.row.taskDetails}
            taskToName={params.row.taskToName}
            taskToOn={params.row.taskToOn}
            acknowledgeStatus={params.row.acknowledgeStatus}
            acknowledgeOn={params.row.acknowledgeOn}
          />
        </>
      ) : (
        <Box>No Records</Box>
      ),
  },
];
